import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PhoneAndroid from '@mui/icons-material/PhoneAndroid';

import { Auth } from 'aws-amplify';

const onLogout = () => {
  Auth.signOut();
};

export const Logout = (
  <React.Fragment>
    <ListItemButton onClick={() => onLogout()}>
      <ListItemIcon>
        <PhoneAndroid />
      </ListItemIcon>
      <ListItemText primary="ログアウト" />
    </ListItemButton>
  </React.Fragment>
);
